import React, { ErrorInfo, ReactNode } from "react";
import { errorMessage } from "../../service/service";

export interface LoadingBoundaryProps {
    className?: string;
    errorFallback?: (error: Error) => React.ReactNode;
    fallback: NonNullable<ReactNode> | null;
}

export default class LoadingBoundary extends React.Component<LoadingBoundaryProps> {
    state = {
        error: null
    };

    static getDerivedStateFromError(error: any) {
        return { error: error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {}

    render() {
        if (this.state.error) {
            if (!this.props.errorFallback)
                return (
                    <div className={this.props.className}>
                        {errorMessage(this.state.error)}
                    </div>
                );
            return this.props.errorFallback?.(this.state.error!);
        }

        return (
            <React.Suspense fallback={this.props.fallback}>
                {this.props.children}
            </React.Suspense>
        );
    }
}
